type PersonalNotificationIconProps = {
  icon: string
  size?: number
}

export const PersonalNotificationIcon = ({ icon, size = 24 }: PersonalNotificationIconProps) => {
  const getIconSrc = () => {
    switch (icon) {
      case "info":
        return new URL("../assets/icons/info-icon.svg", import.meta.url).href
      case "present":
        return new URL("../assets/icons/present-icon.svg", import.meta.url).href
      case "warning":
        return new URL("../assets/icons/warning-icon.svg", import.meta.url).href
      default:
        return new URL("../assets/icons/info-icon.svg", import.meta.url).href
    }
  }

  const getAlt = () => {
    switch (icon) {
      case "info":
        return "お知らせ"
      case "present":
        return "プレゼント"
      case "warning":
        return "警告"
      default:
        return icon
    }
  }

  return <img src={getIconSrc()} alt={getAlt()} style={{ width: size, height: size }} />
}
